/* eslint-disable */
const { createLogger, format, transports } = require('winston');
const { Timber }          = require("@timberio/node");
const { TimberTransport } = require("@timberio/winston");
const timber              = new Timber("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2FwaS50aW1iZXIuaW8vIiwiZXhwIjpudWxsLCJpYXQiOjE1NTgwMTk5ODUsImlzcyI6Imh0dHBzOi8vYXBpLnRpbWJlci5pby9hcGlfa2V5cyIsInByb3ZpZGVyX2NsYWltcyI6eyJhcGlfa2V5X2lkIjoxNTQ0LCJ1c2VyX2lkIjoiYXBpX2tleXwxNTQ0In0sInN1YiI6ImFwaV9rZXl8MTU0NCJ9.xe5RT3YyXuxItd9zDU-Km9vH9sYpQdNbVCTHZlFGSJk", "17499");

const logger = createLogger({
  level: 'debug',
  format: format.combine(
    format.colorize(),
    format.timestamp({
      format: 'YYYY-MM-DD HH:mm:ss'
    }),
    format.printf(info => `[${info.timestamp}] [${info.level}]: ${info.message}`)
  ),
  transports: [
    new TimberTransport(timber),
    new transports.Console({
      level: 'debug',
      format: format.combine(
        format.colorize(),
        format.timestamp({
          format: 'YYYY-MM-DD HH:mm:ss'
        }),
        format.printf(info => `[${info.timestamp}] [${info.level}]: ${info.message}`)
      )
    })
  ]
});


module.exports = logger;